import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { UpdateField } from '@webapp/store/release/action-creators';

import { Option } from '@webapp/types/common/option';
import { ReleaseHistory } from '@common/types/release/release-history';

import Toggle from '@components/actions/toggle';
import NewReleaseTab from './new-release-tab';
import PreviousReleaseTab from './previous-release-tab';

const HISTORY_TYPES: Option<ReleaseHistory>[] = [
  { label: 'New Release', value: 'new' },
  { label: 'Previously Released', value: 'previous' },
];

interface RelaseHistoryCtrlProps {
  className?: string;
  releaseHistory: ReleaseHistory;
  updateReleaseHistory: (
    history: ReleaseHistory
  ) => UpdateField<'releaseHistory'>;
}

const mapStateToProps = (state: AppState) => {
  return {
    releaseHistory: state.release.release?.releaseHistory || 'new',
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateReleaseHistory: (history: ReleaseHistory) =>
    dispatch(new UpdateField<'releaseHistory'>('releaseHistory', history)),
});

export const RelaseHistoryCtrl: React.FC<RelaseHistoryCtrlProps> = ({
  releaseHistory,
  updateReleaseHistory,
  className,
}) => {
  const handleHistoryChange = (value: string) => {
    updateReleaseHistory(value as ReleaseHistory);
  };

  return (
    <div className={className}>
      <Toggle
        className="toggle"
        options={HISTORY_TYPES}
        value={releaseHistory}
        onChange={(value) => handleHistoryChange(value)}
      />
      {releaseHistory === 'previous' && (
        <PreviousReleaseTab className="mb-10" />
      )}
      <NewReleaseTab />
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RelaseHistoryCtrl)`
  .toggle {
    margin-bottom: 20px;
  }
  .datepicker-wrapper {
    position: relative;
    .decoration {
      position: absolute;
      top: 50%;
      right: 50px;
      transform: translate(0, -50%);
    }
  }
`);
